import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TModal } from '@apia/components';

export interface IRemoteModal {
  className?: string;
  data?: unknown;
  isLoading: boolean;
  isOpen: boolean;
  size?: TModal['size'];
  title?: string;
}

function getInitialState(): IRemoteModal {
  return { isLoading: false, isOpen: false };
}

const remoteModalsSlice = createSlice({
  name: 'remoteModalsSlice',
  initialState: { modals: {} } as {
    modals: Record<string, IRemoteModal>;
  },
  reducers: {
    close(state, { payload: id }: PayloadAction<string>) {
      if (!state.modals[id]) state.modals[id] = getInitialState();

      state.modals[id].isOpen = false;
    },
    open(
      state,
      {
        payload: { className, id, data, size, title },
      }: PayloadAction<
        { id: string } & Pick<
          IRemoteModal,
          'className' | 'data' | 'title' | 'size'
        >
      >,
    ) {
      if (!state.modals[id]) state.modals[id] = getInitialState();

      state.modals[id].className = className;
      state.modals[id].data = data;
      state.modals[id].isOpen = true;
      state.modals[id].size = size;
      state.modals[id].title = title;
    },
    update(
      state,
      {
        payload: { id, ...rest },
      }: PayloadAction<{ id: string } & Partial<IRemoteModal>>,
    ) {
      if (!state.modals[id]) state.modals[id] = getInitialState();

      state.modals[id] = { ...state.modals[id], ...rest };
    },
  },
});

export const remoteModalsActions = remoteModalsSlice.actions;

export default remoteModalsSlice.reducer;
